const isValidEanStart = (line: string): boolean => {
  const eanRegex = /^\d{8,14}(?:;|$)/
  return eanRegex.test(line.trim())
}

const cleanPrice = (priceString: string | undefined): string => {
  if (!priceString) return ''
  return priceString.replace(/[^\d,]/g, '').replace(',', '.')
}

export const parseEntries = (rawText: string): string[] => {
  const lines = rawText.split(/\r?\n/)
  const entries: string[] = []
  let currentEntryBuffer = ''

  for (const line of lines) {
    const trimmedLine = line.trim()

    if (isValidEanStart(trimmedLine)) {
      if (currentEntryBuffer) {
        entries.push(currentEntryBuffer.trim())
      }

      currentEntryBuffer = line
    } else {
      if (currentEntryBuffer && line) {
        currentEntryBuffer += '\n' + line
      }
    }
  }

  if (currentEntryBuffer) {
    entries.push(currentEntryBuffer.trim())
  }

  return entries.filter((entry) => entry)
}

export const extractProductData = (
  entry: string
): { ean: string; description: string; price: string } | null => {
  if (!entry) return null

  const parts = entry.split(';')
  const ean = parts[0]?.trim()
  const description = parts[1]?.trim() ?? ''

  if (!ean) return null

  let price = ''

  const potentialPrice = parts[2]?.trim()

  if (potentialPrice) {
    const cleanedPriceRegex = /^\d+(\.\d+)?$/

    if (cleanedPriceRegex.test(potentialPrice)) {
      price = potentialPrice
    } else {
      const cleanedPrice = cleanPrice(potentialPrice)
      if (cleanedPriceRegex.test(cleanedPrice)) {
        price = cleanedPrice
      } else {
        console.warn(
          `Invalid price format after cleaning: Raw='${potentialPrice}', Cleaned='${cleanedPrice}'`
        )
        price = ''
      }
    }
  }

  return { ean, description, price }
}
